import styles from "../styles/About.module.css";

const About = () => {
  return (
    <div className={styles.aboutBody}>
      <h1>Hakkında</h1>
      <h3>Yapay zeka yardımı ile görsellerden arkaplan silme uygulaması</h3>
    </div>
  );
};

export default About;
